<template>
  <div class="sidebar">
    <img class="sidebar__logo" :src="logoImg"
         alt="logo" width="190px"/>
    <div class="sidebar__logo__title "> éVALUATION DE VOTRE BESOIN </div>
    <sub-menu v-for="(step, index) in routes"
              :index="index"
              :steps="step.subs"
              :route="step.name"
              :title="$t(`layout.menus.${step.name}`)"
              :key="index + step.name"
              :done="index < activeStep"
    />
  </div>
</template>

<script>
import SubMenu from './SubMenu.vue';
import loading from '@/routes/loading';
import delivery from '@/routes/delivery';
import serviceOffer from '@/routes/serviceOffer';
import furnitures from '@/routes/furnitures';
import logo from '@/assets/img/logo_headline.png';

export default {
  name: 'SideBar',
  components: { SubMenu },
  props: {
    steps: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    routes() {
      return [
        {
          name: 'loading',
          subs: loading.map(({ name }) => name),
        },
        {
          name: 'delivery',
          subs: delivery.map(({ name }) => name),
        },
        {
          name: 'serviceOffer',
          subs: serviceOffer.map(({ name }) => name),
        },
        {
          name: 'furnitures',
          subs: furnitures.map(({ name }) => name),
        },
        {
          name: 'validateConfirm',
        },
      ];
    },
    activeStep() {
      if (this.$route.name === 'validateDone') {
        return this.routes.length;
      }
      return this.routes.findIndex(r => this.$route.name.startsWith(r.name));
    },
    logoImg() {
      return logo;
    },
  },
};
</script>

<style scoped lang="scss">
  .sidebar {
    background-color: $--color-light-grey-blue;
    height: 100%;
    min-height: 100vh;
    width: 100%;
    &__logo{
      margin-top: 40px;
      margin-bottom: 43px;
      margin-left: 50px;
      &__title{
        font-size: 15px;
        color: $--color-text-primary;
        font-style: normal;
        text-align: center;
        font-weight: $--font-weight-600;
        margin-bottom: 27px;
        text-transform: uppercase;
        letter-spacing: 1px;
      }
    }
  }
</style>
